import React, { useEffect, useState } from 'react';
import axios from 'axios';
import FileUploader from '../../components/FileUploader';
import MediaGrid from '../../components/MediaGrid';
import { BACKEND_URL } from '../../Constants';
const MediaLibrary = () => {
  const [files, setFiles] = useState([]);

  const fetchFiles = async () => {
    const res = await axios.get(`${BACKEND_URL}/api/media`);
    setFiles(res.data.files);
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const handleUpload = (newFile) => {
    setFiles((prev) => [...prev, newFile]);
  };

  return (
    <div>
      <h2>Media Library</h2>
      <FileUploader onUpload={handleUpload} />
      <MediaGrid files={files} setFiles={setFiles} />
    </div>
  );
};

export default MediaLibrary;